import axios from 'axios';

function parseProjectParams(project) {
  const parsedProject = Object.assign({}, project);
  // replace all whitespaces
  if (project.withdrawal_iban) parsedProject.withdrawal_iban = project.withdrawal_iban.replace(/\s/g, '');
  // project to_collect is stored on backend in the smallest sub-division of the currency, eg: 1$ = 100
  parsedProject.to_collect *= 100;
  parsedProject.translations_attributes = parsedProject.translations;
  // if language sent in header is the same as chosen translation language, project.story and project.description
  // will always override translations from translations_attributes - this is caused by rails globalize gem
  // anyway, those attributes should be removed to not send redundant data
  delete parsedProject.translations;
  delete parsedProject.story;
  delete parsedProject.description;

  return parsedProject;
}

export default {
  languages() {
    return [
      { locale: 'en', name: 'english' },
      { locale: 'pl', name: 'polish' },
      { locale: 'de', name: 'german' },
      { locale: 'fr', name: 'french' },
      { locale: 'es', name: 'spanish' },
    ];
  },
  new(data) {
    const project = parseProjectParams(data);

    return axios.post('/projects', { project });
  },
  edit(data) {
    const project = parseProjectParams(data);

    return axios.patch(`/projects/${project.id}`, { project });
  },
  destroy(id, succ) {
    axios.delete(`/projects/${id}`).then(() => {
      succ();
    });
  },
  getProjects(succ) {
    axios.get('/projects/').then((response) => {
      succ(response.data);
    });
  },
  getCrowdfundingProjects(succ) {
    axios.get('/projects/crowdfunding').then((response) => {
      succ(response.data);
    });
  },
  getFundraisingProjects(succ) {
    axios.get('/projects/fundraising').then((response) => {
      succ(response.data);
    });
  },
  getProject(id, succ) {
    axios.get(`/projects/${id}`).then((response) => {
      succ(response.data);
    });
  },
  getUserProjects(userId, succ) {
    axios.get(`/users/${userId}/projects`).then((response) => {
      succ(response.data);
    });
  },
  getCategories(succ, isCrowdfunding) {
    axios.get('/categories', { params: { crowdfunding: isCrowdfunding } }).then((response) => {
      succ(response.data);
    });
  },
  verifyProject(id) {
    return axios.post(`/projects/${id}/submit`);
  },
  publishProject(id) {
    return axios.post(`/projects/${id}/publish`);
  },
  contributions(projectId, succ) {
    axios.get(`/projects/${projectId}/contributions`).then((response) => {
      // reward price is stored on backend in the smallest sub-division of the currency, eg: 1$ = 100
      response.data.forEach((contribution) => {
        contribution.amount /= 100;
      });
      succ(response.data);
    });
  },
  search(query, succ, page) {
    axios.get('/search', { params: { search: query, page } }).then((response) => {
      succ(response.data);
    });
  },
  getMainPageProjects(isCrowd, limit, succ) {
    axios.get('/projects/main_page', { params: { crowdfunding: isCrowd, limit } }).then((response) => {
      succ(response.data);
    });
  },
  getPromotedProjects(succ) {
    axios.get('/projects/promoted').then((response) => {
      succ(response.data);
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/projects.js